var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.286,
    height: 68.286,
    viewBox: "0 0 68.286 68.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2845",
    "data-name": "Group 2845",
    transform: "translate(-926 -3585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Note-3",
    transform: "translate(926 3585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H68.286V68.286H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M8.366,16.731H35.68a1.366,1.366,0,0,0,0-2.731H8.366a1.366,1.366,0,1,0,0,2.731Z",
    transform: "translate(12.12 24.24)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M8.366,12.731H35.68a1.366,1.366,0,0,0,0-2.731H8.366a1.366,1.366,0,0,0,0,2.731Z",
    transform: "translate(12.12 17.314)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M8.366,20.731H30.217a1.366,1.366,0,0,0,0-2.731H8.366a1.366,1.366,0,0,0,0,2.731Z",
    transform: "translate(12.12 31.166)",
    fill: "#fd9926"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M41.24,7.463v-4.1a1.366,1.366,0,0,1,2.731,0v4.1H50.8a4.1,4.1,0,0,1,4.1,4.1V49.8a9.56,9.56,0,0,1-9.56,9.56H12.56A9.56,9.56,0,0,1,3,49.8V11.56a4.1,4.1,0,0,1,4.1-4.1h6.829v-4.1a1.366,1.366,0,1,1,2.731,0v4.1H27.583v-4.1a1.366,1.366,0,1,1,2.731,0v4.1Zm0,2.731H30.314v4.1a1.366,1.366,0,1,1-2.731,0v-4.1H16.657v4.1a1.366,1.366,0,1,1-2.731,0v-4.1H7.1A1.366,1.366,0,0,0,5.731,11.56V49.8a6.829,6.829,0,0,0,6.829,6.829H45.337A6.829,6.829,0,0,0,52.166,49.8V11.56A1.366,1.366,0,0,0,50.8,10.194H43.971v4.1a1.366,1.366,0,1,1-2.731,0Z",
    transform: "translate(5.194 3.463)",
    fill: "#0c4767"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M41.24,7.463v-4.1a1.366,1.366,0,0,1,2.731,0v4.1H50.8a4.1,4.1,0,0,1,4.1,4.1V49.8a9.56,9.56,0,0,1-9.56,9.56H12.56A9.56,9.56,0,0,1,3,49.8V11.56a4.1,4.1,0,0,1,4.1-4.1h6.829v-4.1a1.366,1.366,0,1,1,2.731,0v4.1H27.583v-4.1a1.366,1.366,0,1,1,2.731,0v4.1Z",
    transform: "translate(934.194 3591.463)",
    fill: "#fe9920",
    opacity: 0.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.304fa986524a31f48f97a00569f400fa.svg";
export { ForwardRef as ReactComponent };